import { FC } from "react";

interface CopyIconProps {
    color?: string;
}
export const CopyIcon: FC<CopyIconProps> = ({ color = 'white' }) => {
    return <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.7526 10.7806V14.2806C13.7526 17.1973 12.5859 18.3639 9.66927 18.3639H6.16927C3.2526 18.3639 2.08594 17.1973 2.08594 14.2806V10.7806C2.08594 7.86393 3.2526 6.69727 6.16927 6.69727H9.66927C12.5859 6.69727 13.7526 7.86393 13.7526 10.7806Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M18.7526 5.7806V9.2806C18.7526 12.1973 17.5859 13.3639 14.6693 13.3639H13.7526V10.7806C13.7526 7.86393 12.5859 6.69727 9.66927 6.69727H7.08594V5.7806C7.08594 2.86393 8.2526 1.69727 11.1693 1.69727H14.6693C17.5859 1.69727 18.7526 2.86393 18.7526 5.7806Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

}